// removed by extract-text-webpack-plugin
module.exports = {"header":"_2DW6KjOPJESZeaiIClqICj","inner":"_1xRBwwLZ3JOdzjCDl0mXC5","social":"_1wZFo7tnuvoEX5-hURilsb","hamburger":"_3Fz1bRX60gm21Z_jDsy4YF","title":"sXFYcaUvE4rCRSjZ0IA1w","github":"_2XIfHepR7QVhKFoPrRUmWa"};


//////////////////
// WEBPACK FOOTER
// ../components/header/styles.module.css
// module id = 415
// module chunks = 0